module.exports = __webpack_public_path__ + "3e56917ce9c7ee00563f723f6d0a7b53.svg";